export const selectFiscalYearFrag = `
    id
    dateFrom
`